import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectSingularUGCByUsers, selectSingularUGCForCurrentUser } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'iOwnThisTransactions'], Immutable.Map());

export const selectIOwnThisByUsers = selectSingularUGCByUsers('iOwnThis');

export const selectIOwnThisTransactions = createSelector([getTransactions], transactions => transactions);

export const selectIOwnThisForCurrentUser = selectSingularUGCForCurrentUser('iOwnThis');

export default {
  selectIOwnThisByUsers,
  selectIOwnThisTransactions
};
